export enum ApplicationFormSchemaStepLogicFields {
  GROUPS = 'groups',
  ERROR_MESSAGE = 'error_message',
}
